import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { LitElement, html } from 'lit';
import * as dayjs from 'dayjs';
import translations from '../../common/sport/translations';
import css from './style.pcss';
import { helper } from "../../common/helper";
import DefaultPlayerImage from "./images/football-player.png";

//TODO: kucken wei ech et mat den flags maachen..
var Flags = {};
// console.log("FLAGS", Flags, Object.keys(Flags))
var RTLSportPlayer = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLSportPlayer, _LitElement);
  function RTLSportPlayer() {
    var _this;
    _classCallCheck(this, RTLSportPlayer);
    _this = _callSuper(this, RTLSportPlayer);
    _this.language = 'lu';
    _this.assetsUrl = 'https://rtl-sites-assets.rtl.lu';
    if (window.rtlsites) {
      _this.language = window.rtlsites.config.language;
      _this.assetsUrl = window.rtlsites.config.assetsUrl;
    }
    return _this;
  }
  _createClass(RTLSportPlayer, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(RTLSportPlayer.prototype), "connectedCallback", this).call(this);
      this._fetchData();
    }
  }, {
    key: "_fetchData",
    value: function _fetchData() {
      var _this2 = this;
      if (!this.id) return;
      this.location = window.location.origin;
      if (process.env.NODE_ENV == 'development') {
        this.location = "http://localhost:8080";
      }
      var apiUrl = "https://api-gate.rtl.lu/sport";
      apiUrl += '/players/' + this.id + '?lang=' + this.language;
      fetch(apiUrl).then(function (resp) {
        return resp.json();
      }).then(function (resp) {
        _this2.data = resp;
        //console.log(this.data);
      });
    }
  }, {
    key: "_getTranslation",
    value: function _getTranslation(key) {
      if (!translations[key]) {
        console.warn(key + ' is not defined in translations.js!');
      } else return translations[key][this.language];
    }
  }, {
    key: "_showTeam",
    value: function _showTeam(e, id) {
      var link;
      if (this.language === 'fr') link = `/sport/resultats`;
      if (this.language === 'lu') link = `/sport/${this._getTranslation('sport' + this.sport)}/resultater`;
      document.location.href = `${link}/teams/teams?c=${this.competition}&t=${id}`;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      if (this.data == undefined) return html(_t || (_t = _`Loading...`));

      //console.log("PlayerData", this.data)

      var player = this.data;
      var currentSeason = this.data.history[0];
      var trainerStats = ['red_cards', 'yellow_cards', 'yellow_red_cards'];
      var statistics = [];
      for (var _i = 0, _Object$entries = Object.entries(currentSeason.statistics); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];
        if (key === 'card_score') continue;
        if (currentSeason.position === "trainer" && !trainerStats.includes(key)) continue;
        var row = html(_t2 || (_t2 = _`
                <div class="sport-player-stats__row">
                    <div class="sport-player-stats__label">${0}</div>
                    <div class="sport-player-stats__value">${0}</div>
                </div>
            `), this._getTranslation(key), value);
        statistics.push(row);
      }
      var playerImg = `${DefaultPlayerImage}`;
      if (currentSeason.image_url) playerImg = currentSeason.image_url;
      var clubEndText = "";
      if (currentSeason.end_date) {
        clubEndText = ` (${this._getTranslation("until")} ${dayjs(currentSeason.end_date).format("DD.MM.YYYY")})`;
      }
      return html(_t3 || (_t3 = _`
            <style>${0}</style>

            <div class="sport-player">
                <div class="sport-player-top">
                    <div class="sport-player-top__basic">
                        <div class="sport-player__logo" @click=${0}><img src="${0}" alt="${0}" width="120"/></div>
                        <div class="sport-player__number">${0}</div>
                        <div class="sport-player__name">
                            <div class="sport-player__firstname">${0}</div>
                            <div class="sport-player__lastname">${0}</div>
                        </div>
                    </div>
                    <div class="sport-player__img"><img src="${0}" alt="${0}" width="350"/></div>
                    <div class="sport-player-top__detail">
                        <div class="sport-player-detail__info">${0}: <b>${0}</b> ${0}</div>
                        ${0}
                        ${0}
                        ${0}
                    </div>
                    <div class="sport-player-stats">
                        ${0}
                    </div>

                </div>


            </div>
        `), css, function (e) {
        return _this3._showTeam(e, currentSeason.team.id);
      }, currentSeason.team.logo_url, currentSeason.team.name, currentSeason.number, player.first_name, player.last_name, helper.stockify(playerImg, 350), player.formatted_name, this._getTranslation('club'), currentSeason.team.name, clubEndText, player.birthday ? html(_t4 || (_t4 = _`<div class="sport-player-detail__info">${0}: <b>${0} (${0} ${0})</b></div>`), this._getTranslation('birthday'), dayjs(player.birthday).format('DD.MM.YYYY'), dayjs().diff(dayjs(player.birthday), 'year'), this._getTranslation('years')) : '', player.nationalities ? html(_t5 || (_t5 = _`
                        <div class="sport-player-detail__left">
                            ${0}:
                            <b>
                            ${0}
                            </b>
                        </div>`), this._getTranslation('nationality'), player.nationalities.map(function (nationality) {
        return html(_t6 || (_t6 = _`
                                <span class="sport-player-detail__nationality">${0} <img src="${0}/images/flags-alt/${0}.svg" height="18"></span>
                            `), nationality.country, _this3.assetsUrl, nationality.code.toLowerCase());
      })) : '', currentSeason.position ? html(_t7 || (_t7 = _`
                            <div class="sport-player-detail__position">
                                ${0}:
                                <b>${0}</b>
                            </div>
                        `), this._getTranslation('position'), this._getTranslation(currentSeason.position)) : '', statistics);
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        data: {
          type: String
        },
        id: {
          type: Number
        },
        sport: {
          type: Number
        },
        // 1: Football / 2: Basketball / 3: Handball / 4: Volleyball / 5: Deschtennis
        competition: {
          type: Number
        },
        language: {
          type: String
        }
      };
    }
  }]);
  return RTLSportPlayer;
}(LitElement);
export { RTLSportPlayer as default };
window.customElements.define('rtl-sport-player', RTLSportPlayer);